import { render, staticRenderFns } from "./ArchiveFileRow.vue?vue&type=template&id=d452a7e4&"
import script from "./ArchiveFileRow.vue?vue&type=script&lang=js&"
export * from "./ArchiveFileRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports